import React from 'react';
import { RouteComponentProps } from 'react-router';
import { UserListContainer } from '../../epic/user-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <UserListContainer />;
};
